import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import BlogPost, { BlogPostData } from '../../components/blog/BlogPost';

// Import blog data
import blog1Data from '../../data/blog/blog1';
import blog2Data from '../../data/blog/blog2';
import blog3Data from '../../data/blog/blog3';

// Create a mapping of slugs to blog data
const BLOGS: Record<string, BlogPostData> = {
  [blog1Data.slug]: blog1Data,
  [blog2Data.slug]: blog2Data,
  [blog3Data.slug]: blog3Data,
};

const BlogPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  
  // If no slug is provided or the slug doesn't match any blog, redirect to blog index
  if (!slug || !BLOGS[slug]) {
    return <Navigate to="/blog" replace />;
  }
  
  // Load the blog data for the given slug
  const blogData = BLOGS[slug];
  
  return <BlogPost data={blogData} />;
};

export default BlogPage; 